export const EMAIL_INBOX_TYPES = {
  RECEIVED: "received", // Inbox in UI
  SENT: "sent",
  // Meeting invites delivered to the rep's lookalike address. Kept out of the
  // other two views: an invite is machine-generated calendar traffic, not
  // correspondence.
  CALENDAR: "calendar",
} as const;

export const DEFAULT_EMAIL_INBOX_TYPE = EMAIL_INBOX_TYPES.RECEIVED;
